import React, { useState } from "react";
import { motion } from "framer-motion";

export const Tabs = ({
  tabs = [],
  tabsName = [],
  activeTabName = '',
  onTabClick,
  align = 'left'
}) => {
  const [hoveredTabIndex, setHoveredTabIndex] = useState(null);

  const getAlignmentClass = () => {
    switch (align) {
      case 'left':
        return 'justify-start';
      case 'right':
        return 'justify-end';
      case 'center':
      default:
        return 'justify-center';
    }
  };

  const tabItems = tabs.length > 0
    ? tabs
    : tabsName.map(name => ({ name, icon: null }));

  return (
    <div className="w-full">
      <div className={`flex flex-wrap gap-2 ${getAlignmentClass()}`}>
        {tabItems.map((tab, index) => {
          const { name, icon, id } = tab;
          const tabIdentifier = id || name || index;
          const isActive = activeTabName === tabIdentifier;
          const isHovered = hoveredTabIndex === index;

          return (
            <button
              key={`tab-${index}`}
              type="button"
              onClick={() => onTabClick(tabIdentifier)}
              onMouseEnter={() => setHoveredTabIndex(index)}
              onMouseLeave={() => setHoveredTabIndex(null)}
              className={`relative px-4 py-1.5 text-sm font-medium transition-colors duration-200
                rounded-tl-2xl rounded-tr-2xl rounded-br-2xl cursor-pointer bg-gray-100
                ${isActive ? 'text-white' : 'text-[#3f1057]/50 trasition duration-300 hover:text-[#672c71]'}
              `}
            >
              <span className="relative z-10 flex items-center gap-2">
                {icon && <span className="icon">{icon}</span>}
                {name && <span>{name}</span>}
              </span>

              {!isActive && isHovered && (
                <span className="transition duration-300 absolute inset-0 z-0 bg-slate-100 rounded-tl-2xl rounded-tr-2xl rounded-br-2xl transition-all" />
              )}

              {isActive && (
                <motion.span
                  layoutId="tabs-pill"
                  transition={{ type: "spring", duration: 0.5 }}
                  className="absolute inset-0 z-0 bg-gradient-to-r from-[#672c71] to-[#3f1057] rounded-tl-2xl rounded-tr-2xl rounded-br-2xl"
                />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Tabs;
